<template>
    <el-date-picker
            class="mak-date-picker"
            v-model="dateValue"
            format="dd/MM/yyyy HH:mm"/>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'mak-date-picker',
        model: {
            props: 'value',
            event: 'change',
        },
        props: {
            value: {type: [Object, String, Number]},
        },
        data() {
            return {
                dateValue: moment(),
            };
        },
        mounted() {
            if (this.value) {
                // this.dateValue = moment(this.value, 'DD/MM/YYYY HH:mm:ss');
                this.dateValue = moment(this.value, 'YYYY-MM-DD HH:mm:ss');
            } else {
                this.$emit('change', moment().format('YYYY-MM-DD HH:mm:ss'))
            }
        },
        watch: {
            value(to, fr) {
                // console.warn('date value', this.value);
                if (this.value && to !== fr) {
                    this.dateValue = moment(this.value, 'YYYY-MM-DD HH:mm:ss');
                }
            },
            dateValue() {
                const formatted = moment.isMoment(this.dateValue)
                    ? this.dateValue.format('YYYY-MM-DD HH:mm:ss')
                    : moment(this.dateValue).format('YYYY-MM-DD HH:mm:ss');
                this.$emit('change', formatted);
                // console.warn('date obj', this.dateValue);
                // console.warn('date format', this.dateValue.format('YYYY-MM-DD HH:mm:ss'));
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
